import { createApi } from '@reduxjs/toolkit/query/react';
import baseQueryForm from './baseQueryForm';

const grab = createApi({
    reducerPath: 'grab',
    baseQuery: baseQueryForm,
    endpoints: (builder) => ({
        grabmart: builder.mutation({
            query: (param) => ({
                url: 'grab/grabmart',
                method: 'POST',
                body: param,
            }),
        }),
    }),
});
export const { useGrabmartMutation } = grab;
export default grab;